// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteRoom200Response
 */
export interface DeleteRoom200Response {
    /**
     * 
     */
    deleted?: boolean;
}

/**
 * Check if a given object implements the DeleteRoom200Response interface.
 */
export function instanceOfDeleteRoom200Response(value: object): value is DeleteRoom200Response {
    return true;
}

export function DeleteRoom200ResponseFromJSON(json: any): DeleteRoom200Response {
    return DeleteRoom200ResponseFromJSONTyped(json, false);
}

export function DeleteRoom200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteRoom200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
    };
}

export function DeleteRoom200ResponseToJSON(json: any): DeleteRoom200Response {
    return DeleteRoom200ResponseToJSONTyped(json, false);
}

export function DeleteRoom200ResponseToJSONTyped(value?: DeleteRoom200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deleted': value['deleted'],
    };
}

